import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthLogo = () => (
  <div className="flex flex-col items-center">
    <img src="/logo.jpg" alt="Gogoats" className="w-36 h-36 rounded-[32px] object-cover ring-4 ring-white shadow-2xl shadow-cyan-500/30" />
    <p className="font-display font-black text-3xl tracking-tight mt-4text-slate-900">GO<span className="text-cyan-500">GOATS</span></p>
    <p className="text-sm text-slate-500 mt-1">Le match du mardi, sans prise de tête.</p>
  </div>
);

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", f);
      signIn(r.data.token, r.data.user);
      nav("/profil");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-[100dvh] mx-auto max-w-md px-6 py-10 flex flex-col justify-center" data-testid="login-page">
      <AuthLogo />
      <form onSubmit={submit} className="mt-10 space-y-3">
        <input data-testid="login-email" type="email" required autoComplete="email" placeholder="Email" className="gg-input" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <input data-testid="login-password" type="password" required autoComplete="current-password" placeholder="Mot de passe" className="gg-input" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        <button data-testid="login-submit" disabled={busy} className="w-full rounded-2xl bg-cyan-400 text-zinc-950 font-display font-black py-4 active:scale-[0.98] transition disabled:opacity-50">
          {busy ? "CONNEXION…" : "SE CONNECTER"}
        </button>
      </form>
      <p className="text-center text-sm text-slate-500 mt-6">
        Pas encore de compte ? <Link to="/inscription" data-testid="go-register-link" className="text-cyan-600 font-semibold">Créer un compte</Link>
      </p>
      <p className="text-center text-sm mt-3"><Link to="/mot-de-passe-oublie" data-testid="forgot-password-link" className="text-slate-500 underline">Mot de passe oublié ?</Link></p>
      <Link to="/reclamer" data-testid="claim-account-button" className="mt-8 block text-center rounded-2xl border-2 border-dashed border-cyan-300 bg-cyan-50 text-cyan-700 py-3.5 text-sm font-bold">
        Déjà joueur ? Réclamer mon compte
      </Link>
    </div>
  );
}
